import { defineComponent as _defineComponent } from 'vue'

    const __default__ = {
        name: 'SearchPageHotelCardRightBlockSearchTimer', //нужен для stubs
    };

import {
        computed, unref,
    } from 'vue';
    import { wordEnding } from '@ve/services/textModifiers';
    import { useState } from 'vuex-composition-helpers';
    import { NAMESPACE as SEARCH_PAGE_HOTEL_CARD_STORE } from '../store/SearchPageHotelCardStore';

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

    const {
        minutesAfterSearchStarted,
    } = useState(SEARCH_PAGE_HOTEL_CARD_STORE, ['minutesAfterSearchStarted']);

    const timerText = computed(() => `цена ${unref(minutesAfterSearchStarted)} минут${wordEnding(unref(minutesAfterSearchStarted), 'у;ы;')} назад`);

return { __sfc: true,minutesAfterSearchStarted, timerText }
}

})